/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-undef */
import React, {useState} from 'react';
import {
  Drawer, Box, Button,
  Tabs, Tab, AppBar,
} from '@material-ui/core';
import {accessEditorPage} from 'api-lofty';
import toastr from 'toastr';
import {makeStyles} from '@material-ui/core/styles';
import 'toastr/build/toastr.min.css';
import TableVariables from './list/TableVariables';
import ModalAddVariable from './Modal/ModalAddVariable';
import TablePages from './list/TablePages';
import AddPageModal from './Modal/ModalAddPage';
import ClonePage from './Modal/ModalClonePage';

const useStyle = makeStyles(() => ({
  mainBoxContainer: {
    width: '600px',
    padding: '10px',
    backgroundColor: '#242424',
    // height: '100%',
  },
  boxAreaSection: {
    width: '100%',
    // backgroundColor: '#F2F2F2',
    border: '1px solid #BDBDBD',
    // height: '100%',
  },
  boxTitleArea: {
    padding: '20px',
  },
  titleDivisor: {
    height: '1px',
    width: '100%',
    background: '#14569E',
    marginTop: '10px',
    marginBottom: '10px',
  },
  mainTitleStyle: {
    fontSize: '19px',
    fontWeight: 'bold',
    textAlign: 'center',
    // color: '#292151',
    color: '#fff',
  },
  boxVariableContainer: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  titleListStyle: {
    fontSize: '16px',
    color: '#9B9B9B',
    marginTop: '15px',
    marginBottom: '10px',
    fontWeight: '500',
    textAlign: 'center',
  },
  boxOptionsContainer: {
    width: '100%',
    marginTop: '20px',
    marginBottom: '20px',
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  buttonOptionStyle: {
    width: '100%',
    marginRight: '5px',
    color: 'rgba(32, 21, 73, 1)',
    fontWeight: 'bold',
    fontSize: '19px',
    backgroundColor: '#fff',
    border: '2px solid',
    borderColor: 'rgba(32, 21, 73, 1)',
    fontFamily: [
      'Nunito',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
    textTransform: 'none',
  },
  drawerPaper: {
    backgroundColor: '#242424',
  },
}));

function DrawerVariable({
  open, handleClose, localVariables, globalVariables,
  addNewVariableHandler, deleteVariable, token, idProject,
  idPage, dataPages, handleReloadPages,
}) {
  const classes = useStyle();
  const [openDialog, setOpenDialog] = useState(false);
  const [typeAddition, setTypeAddition] = useState('');
  const [tabSelect, setTabSelect] = React.useState(0);
  const [openCloneModal, setOpenCloneModal] = useState(false);
  const [idFromPage, setIdFromPage] = useState('');
  const [openAddPage, setOpenAddPage] = useState(false);

  function handleOpenDialog(type) {
    setTypeAddition(type);
    setOpenDialog(true);
  }

  // FUNCTIONS FOR PAGES (AVOID TOO MANY CALLS)
  function modalCloneProcedure(e) {
    setIdFromPage(e);
    setOpenCloneModal(true);
  }

  const handleOpenOnNewTab = (url) => {
    const newWindow = window.open(url, '_self', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  return (
    <Drawer
      open={open}
      onClose={() => handleClose()}
      anchor="right"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Box component="div" className={classes.mainBoxContainer}>
        <Box component="div" className={classes.boxAreaSection}>
          <Box component="div" className={classes.boxTitleArea}>
            <Box component="div" className={classes.mainTitleStyle}>
              Configuraciones
            </Box>
            <Box component="div" className={classes.titleDivisor} />
          </Box>
          <AppBar position="static">
            <Tabs
              value={tabSelect}
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#fff',
                },
              }}
              style={{background: '#242424'}}
            >
              <Tab label="Estados Local" onClick={() => setTabSelect(0)} style={{width: '33%', fontWeight: 600}} />
              <Tab label="Variables Global" onClick={() => setTabSelect(1)} style={{width: '33%', fontWeight: 600}} />
              <Tab label="Paginas" onClick={() => setTabSelect(2)} style={{width: '33%', fontWeight: 600}} />
            </Tabs>
          </AppBar>
          <Box style={{display: tabSelect === 0 ? 'block' : 'none'}}>
            {tabSelect === 0 && (
            <>
              <Box component="div" className={classes.boxOptionsContainer}>
                <Box component="div" className={classes.titleListStyle}>
                  Variables Locales
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.buttonOptionStyle}
                  onClick={() => handleOpenDialog('local')}
                >
                  Agregar Local
                </Button>
              </Box>
              <Box component="div" className={classes.boxVariableContainer}>
                <TableVariables data={localVariables} variableType="local" deleteVariable={(e) => deleteVariable(e)} />
              </Box>
            </>
            )}
          </Box>
          <Box style={{display: tabSelect === 1 ? 'block' : 'none'}}>
            <Box component="div" className={classes.boxOptionsContainer}>
              <Box component="div" className={classes.titleListStyle}>
                Variables Globales
              </Box>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.buttonOptionStyle}
                onClick={() => handleOpenDialog('global')}
              >
                Agregar Global
              </Button>
            </Box>
            <Box component="div" className={classes.boxVariableContainer}>
              <TableVariables data={globalVariables} variableType="global" deleteVariable={(e) => deleteVariable(e)} />
            </Box>
          </Box>
          <Box style={{display: tabSelect === 2 ? 'block' : 'none'}}>
            <Box component="div" className={classes.boxOptionsContainer}>
              <Box component="div" className={classes.titleListStyle}>
                Paginas
              </Box>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.buttonOptionStyle}
                onClick={() => setOpenAddPage(true)}
              >
                Agregar Pagina
              </Button>
            </Box>
            <Box component="div" className={classes.boxVariableContainer}>
              <TablePages
                data={dataPages}
                clonePage={(e) => modalCloneProcedure(e)}
                viewEditor={async (idData) => {
                  const resTokenEditor = await accessEditorPage({token});
                  const url = `${resTokenEditor.url}/page/${idProject}/${idData}?accesstoken=${resTokenEditor.token}`;
                  handleOpenOnNewTab(url);
                }}
                idPage={idPage}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <ModalAddVariable
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            type={typeAddition}
            handleCloseAddVariable={() => setOpenDialog(false)}
            addVariable={(e) => addNewVariableHandler(e)}
            token={token}
            idProject={idProject}
            idPage={idPage}

          />
        </Box>
        <Box>
          <AddPageModal
            open={openAddPage}
            pageData={dataPages}
            handleClose={() => setOpenAddPage(false)}
            handleReload={() => handleReloadPages()}
            // error={(error) => {
            //   if (error.info) {
            //     toastr.options = {
            //       positionClass: 'toast-top-right',
            //       hideDuration: 300,
            //       timeOut: 6000,
            //     };
            //     toastr.clear();
            //     setTimeout(() => toastr.error(`error: \n ${error.info}`), 300);
            //   } else {
            //     toastr.options = {
            //       positionClass: 'toast-top-right',
            //       hideDuration: 300,
            //       timeOut: 6000,
            //     };
            //     toastr.clear();
            //     setTimeout(() => toastr.error('Error no se pudo clonar'), 300);
            //   }
            // }}
            idProject={idProject}
            token={token}
          />
        </Box>
        <Box>
          <ClonePage
            _id={idFromPage}
            open={openCloneModal}
            idProject={idProject}
            token={token}
            onClose={() => setOpenCloneModal(false)}
            onError={(error) => {
              if (error.info) {
                toastr.options = {
                  positionClass: 'toast-top-right',
                  hideDuration: 300,
                  timeOut: 6000,
                };
                toastr.clear();
                setTimeout(() => toastr.error(`error: \n ${error.info}`), 300);
              } else {
                toastr.options = {
                  positionClass: 'toast-top-right',
                  hideDuration: 300,
                  timeOut: 6000,
                };
                toastr.clear();
                setTimeout(() => toastr.error('Error no se pudo clonar'), 300);
              }
            }}
            onSuccess={() => {
              setOpenCloneModal(false);
              toastr.options = {
                positionClass: 'toast-top-right',
                hideDuration: 300,
                timeOut: 6000,
              };
              toastr.clear();
              setTimeout(() => toastr.success('Se ha clonado la  pagina de forma exitosa'), 300);
              handleReloadPages();
            }}
            pageData={dataPages}
          />
        </Box>
      </Box>
    </Drawer>
  );
}

export default DrawerVariable;
